import axios from 'axios';
import { userService } from '../_services';

export function apiClient(apiPath) {

let user = JSON.parse(localStorage.getItem('user'));
let header = {};
if (user && user.token) {
    header = { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'application/json' };
} else {
    //Login
    userService.logout();
    router.push('/login');
}

const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/${apiPath}`,
    withCredentials: false,
    headers: header
  })
  return apiClient
}